module.exports = __webpack_public_path__ + "static/media/avatar-default.dabb201c.png";